<!-- Toast 容器，負責顯示所有 toast 訊息 -->
<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[99999] flex flex-col gap-2">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="[
            'min-w-[300px] p-4 rounded-lg shadow-lg transform transition-all duration-300',
            {
              'bg-mx-success-tint border-l-4 border-mx-success': toast.type === 'success',
              'bg-mx-warning-tint border-l-4 border-mx-warning': toast.type === 'warning',
              'bg-mx-danger-tint border-l-4 border-mx-danger': toast.type === 'error',
            },
          ]"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <component
                :is="getIcon(toast.type)"
                class="w-5 h-5 mr-2"
                :class="{
                  'text-mx-success': toast.type === 'success',
                  'text-mx-warning': toast.type === 'warning',
                  'text-mx-danger': toast.type === 'error',
                }"
              />
              <p
                :class="{
                  'text-mx-success-strong': toast.type === 'success',
                  'text-mx-warning-strong': toast.type === 'warning',
                  'text-mx-danger-strong': toast.type === 'error',
                }"
              >
                {{ toast.message }}
              </p>
            </div>
            <button
              @click="toastStore.removeToast(toast.id)"
              class="ml-4 text-mx-ink-muted hover:text-mx-ink-secondary transition-colors"
            >
              <X class="w-5 h-5" />
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { CircleCheck, CircleX, TriangleAlert } from 'lucide-vue-next';
import { X } from 'lucide-vue-next';
import { useToastStore } from '~/stores/toast';

const toastStore = useToastStore();
const toasts = computed(() => toastStore.toasts);

const getIcon = (type: string) => {
  switch (type) {
    case 'success':
      return CircleCheck;
    case 'warning':
      return TriangleAlert;
    case 'error':
      return CircleX;
    default:
      return CircleCheck;
  }
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style> 